import { Link } from 'react-router-dom';
import { cn } from '../utils/cn';

const BRAND_ICON_SRC = '/branding/waapleads-icon.svg?v=2';

const TONES = {
  light: {
    title: 'text-[#080707]',
    accent: 'text-[var(--slds-color-brand)]',
    subtitle: 'text-[#706E6B]',
  },
  dark: {
    title: 'text-white',
    accent: 'text-[#0D9DDA]',
    subtitle: 'text-[#C9C9C9]/80',
  },
};

function BrandLogoInner({
  className,
  markClassName,
  wordmarkClassName,
  tone = 'light',
  size = 44,
  showText = true,
  subtitle,
}) {
  const palette = TONES[tone] || TONES.light;
  const compact = size <= 36;

  return (
    <div className={cn('inline-flex max-w-full items-center gap-3 overflow-hidden', className)}>
      <img
        src={BRAND_ICON_SRC}
        alt="WaapLeads icon"
        width={size}
        height={size}
        className={cn('shrink-0 drop-shadow-[0_14px_28px_rgba(37,99,235,0.18)]', markClassName)}
      />
      {showText ? (
        <div className={cn('min-w-0 max-w-full overflow-hidden', wordmarkClassName)}>
          <div className="flex items-baseline gap-1.5 leading-none">
            <span className={cn(compact ? 'text-[18px]' : 'text-xl', 'truncate font-black tracking-[-0.06em]', palette.title)}>
              WaapLeads
            </span>
            <span className={cn(compact ? 'text-[9px]' : 'text-[11px]', 'shrink-0 font-extrabold uppercase tracking-[0.24em]', palette.accent)}>
              CRM
            </span>
          </div>
          {subtitle ? (
            <div className={cn(compact ? 'text-[8px]' : 'text-[10px]', 'mt-1 truncate font-semibold uppercase tracking-[0.18em]', palette.subtitle)}>
              {subtitle}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export function BrandLogo(props) {
  return <BrandLogoInner {...props} />;
}

export function BrandLink({ to = '/', ...props }) {
  return (
    <Link to={to} className="inline-flex">
      <BrandLogoInner {...props} />
    </Link>
  );
}

export default BrandLogo;
